import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {TenantService} from '@shared/services';

TenantService.loadConfiguration()
  .then(() => {
    platformBrowserDynamic(
    ).bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });
